// countryCodes.ts

const countryNameToIso: Record<string, string> = {
  // Austria
  austria: 'AT',
  österreich: 'AT',

  // Belgium
  belgium: 'BE',
  belgië: 'BE',
  belgique: 'BE',
  belgien: 'BE',

  // Bulgaria
  bulgaria: 'BG',
  българия: 'BG',

  // Croatia
  croatia: 'HR',
  hrvatska: 'HR',

  // Cyprus
  cyprus: 'CY',
  κύπρος: 'CY',
  kıbrıs: 'CY',

  // Czech Republic
  'czech republic': 'CZ',
  czechia: 'CZ',
  'česká republika': 'CZ',

  // Denmark
  denmark: 'DK',
  danmark: 'DK',

  // Estonia
  estonia: 'EE',
  eesti: 'EE',

  // Finland
  finland: 'FI',
  suomi: 'FI',

  // France
  france: 'FR',
  'république française': 'FR',

  // Germany
  germany: 'DE',
  deutschland: 'DE',

  // Greece
  greece: 'GR',
  ελλάδα: 'GR',

  // Hungary
  hungary: 'HU',
  magyarország: 'HU',

  // Ireland
  ireland: 'IE',
  éire: 'IE',

  // Italy
  italy: 'IT',
  italia: 'IT',

  // Latvia
  latvia: 'LV',
  latvija: 'LV',

  // Lithuania
  lithuania: 'LT',
  lietuva: 'LT',

  // Luxembourg
  luxembourg: 'LU',
  luxemburg: 'LU',
  luxembourgish: 'LU',

  // Malta
  malta: 'MT',
  'repubblika ta’ malta': 'MT',

  // Netherlands
  netherlands: 'NL',
  holland: 'NL',
  nederland: 'NL',

  // Poland
  poland: 'PL',
  polska: 'PL',

  // Portugal
  portugal: 'PT',
  português: 'PT',

  // Romania
  romania: 'RO',
  românia: 'RO',

  // Slovakia
  slovakia: 'SK',
  'slovak republic': 'SK',
  slovensko: 'SK',

  // Slovenia
  slovenia: 'SI',
  slovenija: 'SI',

  // Spain
  spain: 'ES',
  españa: 'ES',

  // Sweden
  sweden: 'SE',
  sverige: 'SE',

  // --- Extra: Common EU trade partners ---
  // United Kingdom
  'united kingdom': 'GB',
  uk: 'GB',
  'great britain': 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  'northern ireland': 'GB',

  // Norway (not EU)
  norway: 'NO',
  norge: 'NO',
  noreg: 'NO',

  // Switzerland (not EU)
  switzerland: 'CH',
  schweiz: 'CH',
  suisse: 'CH',
  svizzera: 'CH',

  // Iceland (not EU, EEA)
  iceland: 'IS',
  ísland: 'IS',

  // United States
  'united states': 'US',
  usa: 'US',
  us: 'US',
  'united states of america': 'US',
  america: 'US',

  // Canada
  canada: 'CA',

  // China
  china: 'CN',
  中国: 'CN',
  "people's republic of china": 'CN',

  // Japan
  japan: 'JP',
  日本: 'JP',
  nippon: 'JP',

  // India
  india: 'IN',
  bharat: 'IN',
  भारत: 'IN',

  // Brazil
  brazil: 'BR',
  brasil: 'BR',
};

export function getIsoCode(countryName: string): string | null {
  if (!countryName) return null;
  const key = countryName.trim().toLowerCase();
  return countryNameToIso[key] ?? null;
}

export function getCountryNameFromIso(isoCode: string): string | null {
  if (!isoCode) return null;
  const code = isoCode.trim().toUpperCase();

  // Find the first key that maps to this ISO code
  const entry = Object.entries(countryNameToIso).find(
    ([, value]) => value === code
  );

  return entry ? capitalize(entry[0]) : null;
}

function capitalize(str: string) {
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
}
